import { render, staticRenderFns } from "./BoCustomerVouchersPurchasedDatatable.vue?vue&type=template&id=bd906fe8&scoped=true"
import script from "./BoCustomerVouchersPurchasedDatatable.vue?vue&type=script&lang=js"
export * from "./BoCustomerVouchersPurchasedDatatable.vue?vue&type=script&lang=js"
import style0 from "./BoCustomerVouchersPurchasedDatatable.vue?vue&type=style&index=0&id=bd906fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd906fe8",
  null
  
)

export default component.exports